<template>
  <div class="info">
    <template v-if="type === 'job'">
      <p class="title">任职资格：</p>
      <p v-html="info.description.replace(/\s/g, '<br/>')"></p>
      <p class="title">岗位职能：</p>
      <p v-html="info.requirements.replace(/\s/g, '<br/>')"></p>
      <p class="title">候选人要求：</p>
      <p>性别要求：{{ info.gender_id | sexy }}</p>
      <p>
        学校类型：{{
        info.school_type == 0
        ? "不限"
        : info.school_type == 1
        ? "985/211"
        : "海归"
        }}
      </p>
      <p>工作经验：{{ info.experience_name }}</p>
      <p>学历要求：{{ info.education_name }}</p>
      <p class="title" style="padding-top:20px">职位进展：</p>
      <p>{{ info.recruitment_progress }}</p>
      <p class="title">其他说明：</p>
      <div>职位级别： {{ info.level }}</div>
      <div>薪资制度： {{ info.salary_type_name }}</div>
      <div>试用期薪资比例：{{ info.probationary_salary_ratio }}%</div>
      <div>下属团队：{{ info.subordinate_team }}</div>
      <div>平级情况：{{ info.samelevel }}</div>
    </template>
    <template v-if="type === 'company'">
      <p class="title inline">公司名称：</p>
      <p v-html="info.name.replace(/\s/g, '<br/>')"></p>
      <p class="title inline">公司地址：</p>
      <p>{{info.city_name + info.dist_name+ info.address}}</p>
      <div v-if="info.logo_url">
        <img src="info.logo_url" alt />
      </div>
      <p class="title">公司介绍：</p>
      <p v-html="info.introduction.replace(/\s/g, '<br/>')"></p>
    </template>
    <template v-if="type === 'level'">
      <span class="level">职位评级：</span>
      <p class="top">
        <span>甲方委托猎企数：</span>
        <span>{{ info.num_published_platforms_name }}</span>
      </p>
      <p>
        <span>面向社会已开放时间：</span>
        <span>{{ info.open_duration_name }}</span>
      </p>
      <p>
        <span>职位紧急程度：</span>
        <span>{{ info.urgency_level_name }}</span>
      </p>
    </template>
    <template v-if="type === 'notice'">
      <span class="level">职位备注：</span>
      <p class="top">
        <span>面试流程：</span>
        <span>{{ info.interview_times_name }}</span>
      </p>
      <p>
        <span>职位卖点：</span>
        <span v-for="(item, index) in info.selling_point_tags" :key="index">
          {{
          item
          }}
        </span>
      </p>
      <p>
        <span>招聘原因：</span>
        <span v-for="(item, index) in info.recruitment_reason_tags" :key="index">{{ item }}</span>
      </p>
      <p>
        <span>搜寻方向：</span>
        <span>{{ info.directions }}</span>
      </p>
      <p>
        <span>职位进展：</span>
        <span>{{ info.recruitment_progress }}</span>
      </p>
      <p>
        <span>附件：</span>
        <span v-for="(item, index) in info.attachments" :key="index">
          {{
          item
          }}
        </span>
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: "info",
  props: {
    type: {
      type: String
    },
    info: {
      type: Object,
      default: () => {
        {
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.info {
  padding: 30px 10px;
  p {
    margin-bottom: 25px;
    line-height: 18px;
    &.title {
      font-weight: bold;
      font-size: 16px;
      &.inline {
        float: left;
        margin-right: 5px;
        margin-bottom: 15px;
      }
    }
  }
  .level {
    font-weight: bold;
    font-size: 16px;
  }
  .top {
    margin-top: 20px;
  }
}
</style>
